import React from "react";
import { Row, Col } from "react-flexbox-grid";
import styles from "../styles";

import { TextField, EntitySelector, IconButton } from "components/support";

const Items = ({
  item,
  productSearchOptions,
  onSelectProduct,
  onDelete,
  onChange
}) => (
  <Row>
    <Col xs={8} lg={8}>
      <EntitySelector
        label="Produto"
        title="Selecionar Produto"
        value={item.name}
        searchOptions={productSearchOptions}
        onSelect={onSelectProduct}
        parser={item => ({ key: item.uuid, title: item.name })}
        nullSelection={{ uuid: "", name: "" }}
      />
    </Col>
    <Col xs={2} lg={3}>
      <TextField
        fullWidth
        label="Quantidade"
        value={item.quantity}
        onChange={onChange}
      />
    </Col>
    <Col xs={2} lg={1}>
      <div style={styles.delete}>
        <IconButton mini icon="delete" onClick={onDelete} />
      </div>
    </Col>
  </Row>
);

export default Items;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/kit-info/items/index.jsx